export default "__VITE_ASSET__jdaKWzxDdLISUlRyIgaZpQ__ 480w, __VITE_ASSET__QqEbJhCkYMH2zruLVeLYhA__ 848w";